/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsLeftRightBrackets: {
  name: 'arrows-left-right-brackets';
  data: string;
} = {
  name: 'arrows-left-right-brackets',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h3a1 1 0 0 1 0 2H4v14h3a1 1 0 1 1 0 2H4a2 2 0 0 1-2-2V5Zm7.707 4.293a1 1 0 0 1 0 1.414L9.414 11h5.172l-.293-.293a1 1 0 0 1 1.414-1.414l2 2a1 1 0 0 1 0 1.414l-2 2a1 1 0 0 1-1.414-1.414l.293-.293H9.414l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 0ZM17 3a1 1 0 1 0 0 2h3v14h-3a1 1 0 1 0 0 2h3a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-3Z" fill="currentColor"/></svg>`,
};
